import type { Routes } from "@angular/router";
import { MainLayoutComponent } from "../../layout/main-layout/main-layout.component";

export default [
	{
		path: "library",
		component: MainLayoutComponent,
		children: [
			{
				path: "",
				loadComponent: () =>
					import("./library.component").then((c) => c.LibraryComponent),
			},
			{
				path: "brochures",
				loadComponent: () =>
					import("./library-brochures/library-brochures.component").then(
						(c) => c.LibraryBrochuresComponent,
					),
			},
			{
				path: "brochures/:id",
				loadComponent: () =>
					import(
						"./library-brochure-details/library-brochure-details.component"
					).then((c) => c.LibraryBrochureDetailsComponent),
			},
			{
				path: "services",
				loadComponent: () =>
					import("./library-services/library-services.component").then(
						(c) => c.LibraryServicesComponent,
					),
			},
			{
				path: "service/:serviceId",
				loadComponent: () =>
					import(
						"./library-service-details/library-service-details.component"
					).then((c) => c.LibraryServiceDetailsComponent),
			},
			{
				path: "videos",
				loadComponent: () =>
					import("./library-videos/library-videos.component").then(
						(c) => c.LibraryVideosComponent,
					),
			},
			{
				path: "videos/:category",
				loadComponent: () =>
					import("./library-videos-list/library-videos-list.component").then(
						(c) => c.LibraryVideosListComponent,
					),
			},
		],
	},
] satisfies Routes;
